import React, { useState, useEffect } from "react";
import moment from "moment/moment";
import axiosInstance from "../../../../axios";
import "./webinar.scss";
import { Link } from "react-router-dom";
import { Loading } from "../../../Other/Loading";
import { AuthorizedWrapper } from "../../../Other/AuthorizedWrapper";
import { getS3URL } from "../../../../_helpers";
import { useNavigate, useParams } from "react-router";
import { useSelector } from "react-redux";

const WebinarEvents = () => {
  const now = new Date();
  const firstDay = moment(
    new Date(now.getFullYear(), now.getMonth(), 1)
  ).format("YYYY MM,DD");
  const lastDay = moment(
    new Date(now.getFullYear(), now.getMonth() + 1, 0)
  ).format("YYYY MM,DD");

  const [data, SetData] = useState([]);
  const [startRequest, setStartRequest] = useState();
  const [fetchResponse, setFetchResponse] = useState(false);
  const [webinarStatus, setWebinarStatus] = useState(null);
  const [statusPopUp, setStatusPop] = useState(false);

  const navigate = useNavigate();

  const { user } = useSelector((state) => state.users);
  const slugify = (text) => {
    return text
      .toString()
      .toLowerCase()
      .replace(/\s+/g, "-")
      .replace(/[^\w\-]+/g, "")
      .replace(/\-\-+/g, "-")
      .replace(/^-+/, "")
      .replace(/-+$/, "");
  };
  const handleViewProgram = (course) => {
    const slug = slugify(course.CourseName);
    const id = course.ID;
    //console.log(`Navigating to: /${slug}-${id}`);
    // navigate(`/${slug}/${id}`, { state: { course: course } });
    navigate(`/${slug}`, { state: { course: course } });
  };
  useEffect(() => {
    const fetchWebinarData = async () => {
      setFetchResponse(true);
      try {
        const response = await axiosInstance.get(
          `webinar/all?startDate=${firstDay}&endDate=${lastDay}`
        );
        //console.log("responsesssssss", response);
        SetData(response.data.data);
      } catch (err) {
        console.error("Error fetching webinar data:", err);
      } finally {
        setFetchResponse(false);
      }
    };

    fetchWebinarData();
  }, []);


  const webinarCreationProcess = async (id, index) => {
    setStartRequest(index);
    try {
      const { data: { data, message } } = await axiosInstance.get(`webinar/join?webinarId=${id}`);
      if (data) {
        window.location.href = data;
      } else {
        setWebinarStatus(message);
      }
    } catch (err) {
      console.error("Error joining webinar:", err);
    }
  };

  const handleWebinar = () => {
    navigate("/dashboard/CourseBuilder");
  };

  return (
    <>
      <section className="container-wrapper">
        <div className="dashboard-container-new !mb-6">
          <p>Webinar List</p>
        </div>
        {user.role == 2 ? (
          ""
        ) : (
          <div className="create-course-btn-webinar" onClick={handleWebinar}>
            Add Webinar
          </div>
        )}
        {fetchResponse && <Loading />}
        {data?.length == 0 ? (
          <>
            {!fetchResponse && (
              <div className="event-card">
                <span className="record-not-found">No Events Founds</span>
              </div>
            )}
          </>
        ) : (
          data?.map((events, index) => (
            // <div class="event-card">
            //   <div class="left">
            //     <div class="date-time dt1">
            //       <p class="date">Webinar Date</p>
            //       <p class="date">
            //         {moment(events.webinarDate).format("DD-MM-YYYY")}
            //       </p>
            //       {/* <p class="time">{events.startTime}</p> */}
            //     </div>

            //     <div class="event-info">
            //       <h3 class="event-name">
            //         <span className="webiner-detail-heading">Event name:</span>
            //         {events.eventName}
            //       </h3>
            //       <h3 class="event-name">
            //         <span className="webiner-detail-heading">Start Time:</span>
            //         {events.startTime}
            //       </h3>
            //     </div>
            //   </div>
            //   <div class="right">
            //     {startRequest !== index && (
            //       <button
            //         className="btn webinarStart"
            //         onClick={() => webinarCreationProcess(events.id, index)}
            //       >
            //         <span className="display-flex-09">
            //           <AuthorizedWrapper authorizedRoles={["Instructor"]}>
            //             <div>START</div>
            //           </AuthorizedWrapper>
            //           <AuthorizedWrapper authorizedRoles={["Student"]}>
            //             <div>Join</div>
            //           </AuthorizedWrapper>
            //           <i className="icon icon-video webiner-now-0" />
            //         </span>
            //       </button>
            //     )}
            //     {startRequest === index && <Loading></Loading>}
            //   </div>{" "}
            // </div>
            <div className="main studentPurchase" key={index}>
              <div className="img-container">
                <img
                  src={getS3URL(events.imageFiles[0].fileName)}
                  className="img"
                  alt="courseImage"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = require("../../../../assets/images/bgimages.webp");
                  }}
                />
              </div>

              <div className="content">
                <div className="content-inner">
                  <div className="inner-top">
                    <div className="inner-top-flex">
                      <div className="right studentname webinarDetails">
                        Event Name: {events.eventName}
                      </div>
                      {/* {events.status === 1 && <div class="circle"></div>} */}
                    </div>
                    <div className="inner-top-flex">
                      <div className="right studentname webinarDetails">
                        Course Name: {events.CourseName}
                      </div>
                    </div>
                    <div className="inner-top-flex">
                      <p className="courseNameResponsive webinarDetails">
                        Webinar Date :{" "}
                        {moment(events.webinarDate).format("DD-MM-YYYY")}
                      </p>
                    </div>

                    <div className="inner-top-flex">
                      <p className="courseNameResponsiveAgain webinarDetails">
                        Start Time: {events.startTime}
                      </p>
                    </div>
                    <div className="inner-top-flex">
                      <p className="courseNameResponsiveAgain webinarDetails">
                        End Time: {events.endTime}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="list-btn-div">
                  <div className="view-section">
                    {/* <Link
                      className="btn-edit-content quickview webinarStart-1"
                      to={{
                        pathname: `/categories/${events.courseId}`,
                      }}
                    >
                      QUICK VIEW
                    </Link> */}
                    <button
                      className="btn quickview webinarStart-1"
                      onClick={() => handleViewProgram(item)}>
                      QUICK VIEW
                    </button>
                  </div>
                  <div className="view-section">
                    {startRequest !== index && (
                      <button
                        className="btn webinarStart"
                        onClick={() => webinarCreationProcess(events.id, index)}
                      >
                        <span className="display-flex-09">
                          <AuthorizedWrapper authorizedRoles={["Instructor"]}>
                            <div>START</div>
                          </AuthorizedWrapper>

                          <AuthorizedWrapper authorizedRoles={["Student"]}>
                            <div>Join</div>
                          </AuthorizedWrapper>
                          <i className="icon icon-video webiner-now-0" />
                        </span>
                      </button>
                    )}
                    {startRequest === index && (
                      <div className="loading-webinar-event">
                        <Loading></Loading>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))
        )}

        {statusPopUp && (
          <div className="webinar-joining-alert">
            <div className="custom-popup">
              <div className="custom-popup-inner">
                <div className="EventDeletePreview">
                  <div onClick={() => setStatusPop(false)}>
                    <i className="icon check"></i>
                  </div>
                </div>
                <div className="deleteEventtext">
                  <h1>{webinarStatus}</h1>
                </div>
              </div>
            </div>
          </div>
        )}
      </section>
    </>
  );
};
export default WebinarEvents;
